export default __webpack_public_path__ + "static/media/HometownEvents.0c720e08.png";